import { memo, useRef } from 'react';
import { defaultRowsPerPageOptions } from '../../utils/common';
import { Box, IconButton, Paper, Typography, FormControlLabel, Checkbox } from '@mui/material';
import { style } from './styles';
import CloseIcon from '@mui/icons-material/Close';
import { TransactionTable } from './components/table/table';
import { useTransactions } from './hooks/useTransactions';
import { Modal } from '../../components/modals/Modal';
import Header from './components/header.jsx';
import CustomTablePagination from './components/table/tablePagination.jsx';

export const LedgerTransactionModalv2 = memo(({ open, accountId, onClose, startDate, endDate, includingOpeningBalance }) => {
  const PeriodDropDownModalRef = useRef();
  const {
    data,
    rowsperpage,
    page,
    setfilters,
    filters,
    accountDetails,
    fetchData,
    handleChangePage,
    handleChangeRowsPerPage,
    includeOpening,
    handleOpeningBalanceChange,
    showLinkedInvoiceVsReceipt,
    openingBalanceSec,
    handleShowLinkedInvoiceVsReceiptChange,
  } = useTransactions({
    accountId,
    startDate,
    endDate,
    includingOpeningBalance,
  });
  console.log(data);

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Modal.Header>
          <Box
            sx={{
              backgroundColor: 'primary.main',
              padding: '3px 15px',
              display: 'flex',
              flexDirection: 'row',
              position: 'sticky',
              zIndex: 1,
            }}
          >
            <Box
              sx={{
                flex: 1,
              }}
            >
              <Typography
                sx={{
                  color: '#fff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontWeight: '600',
                  alignItems: 'center',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  {data.loading && !data.AccountName ? 'Loading' : data.AccountName || <span></span>}
                  {data?.AccountTypeFlag ? (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={showLinkedInvoiceVsReceipt}
                          onChange={handleShowLinkedInvoiceVsReceiptChange}
                          sx={{ color: '#fff', '&.Mui-checked': { color: '#fff' } }}
                        />
                      }
                      label="Set-Off"
                      sx={{ color: '#fff', '& .MuiFormControlLabel-label': { color: '#fff' } }}
                    />
                  ) : ''}
                </Box>
                <IconButton aria-label="delete" onClick={onClose}>
                  <CloseIcon sx={{ color: '#fff' }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>
        </Modal.Header>
        <Modal.Body>
          <Paper sx={style}>
            <Header
              PeriodDropDownModalRef={PeriodDropDownModalRef}
              rowsperpage={rowsperpage}
              data={data}
              setfilters={setfilters}
              filters={filters}
              fetchData={fetchData}
              includeOpening={includeOpening}
              handleOpeningBalanceChange={handleOpeningBalanceChange}
            />
            <TransactionTable
              data={data}
              accountDetails={accountDetails}
              page={page}
              rowsperpage={rowsperpage}
              showLinkedInvoiceVsReceipt={showLinkedInvoiceVsReceipt}
              fetchData={fetchData}
              filters={filters}
              openingBalanceSec={openingBalanceSec}
            />
          </Paper>
        </Modal.Body>
        <Modal.Footer>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CustomTablePagination
              rowsPerPage={rowsperpage}
              rowsPerPageOptions={defaultRowsPerPageOptions}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              count={data.count}
            />
          </Box>
        </Modal.Footer>
      </Modal>
    </>
  );
});
